const news = [
  {
    // 文章
    id: "64",
    title: "【TSK｜國際注射線上研討會-梁仲斌 醫師】",
    time: "2026/10/27",
    link: "/news/64",
    src: require("@/assets/images/zh-TW/news/new_64.jpg"),
    component: () => import("@/components/news/News64.vue"),
    video: false,
  },
  {
    // 文章
    id: "63",
    title: "【TSK｜國際注射線上研討會】",
    time: "2026/10/15",
    link: "/news/63",
    src: require("@/assets/images/zh-TW/news/new_63.jpg"),
    component: () => import("@/components/news/News63.vue"),
    video: false,
  },
  { // 影片
    id: "62",
    title: "【 TSK | AMWC Asia-TDAC 花絮影片 】",
    time: "2026/05/04",
    src: require("@/assets/images/zh-TW/news/new_62.jpg"),
    link: "https://www.youtube.com/embed/Er-XAELX0MA?si=Zosy56zwweu2ZFxp",
    video: true,
  },
  {
    // 文章
    id: "61",
    title: "【 TSK | AMWC Asia-TDAC 】",
    time: "2026/04/02",
    link: "/news/61",
    src: require("@/assets/images/zh-TW/news/new_61.jpg"),
    component: () => import("@/components/news/News61.vue"),
    video: false,
  },
  {
    // 文章
    id: "60",
    title: "【  TSK 線上研討會 】",
    time: "2026/04/02",
    link: "/news/60",
    src: require("@/assets/images/zh-TW/news/new_60.jpg"),
    component: () => import("@/components/news/News60.vue"),
    video: false,
  },
  { // 影片
    id: "59",
    title: "【 TSK | AMWC Asia-TDAC 花絮影片 】",
    time: "2025/05/07",
    src: require("@/assets/images/zh-TW/news/new_59.jpg"),
    link: "https://www.youtube.com/embed/lo-bBAmKwL8",
    video: true,
  },
  {
    // 文章
    id: "58",
    title: "【 TSK | AMWC Asia-TDAC 】",
    time: "2025/04/21",
    link: "/news/58",
    src: require("@/assets/images/zh-TW/news/new_58.jpg"),
    component: () => import("@/components/news/News58.vue"),
    video: false,
  },
  { // 影片
    id: "57",
    title: "【 TSK | 中華民國美容醫學醫學會 花絮影片 】",
    time: "2025/04/14",
    src: require("@/assets/images/zh-TW/news/new_57.jpg"),
    link: "https://www.youtube.com/embed/mM5-y-5n2Lg",
    video: true,
  },
  { // 文章
    id: "56",
    title: "【 TSK | 中華民國美容醫學醫學會 】",
    time: "2025/04/08",
    link: "/news/56",
    src: require("@/assets/images/zh-TW/news/new_56.jpg"),
    component: () => import("@/components/news/News56.vue"),
    video: false,
  },
  { // 影片
    id: "55",
    title: "【 TSK | 台灣醫用雷射光電學會 花絮影片 】",
    time: "2025/04/02",
    src: require("@/assets/images/zh-TW/news/new_55.jpg"),
    link: "https://www.youtube.com/embed/K9yKWwq04nU",
    video: true,
  },
  { // 文章
    id: "54",
    title: "【 TSK | 台灣醫用雷射光電學會 】",
    time: "2025/03/03",
    link: "/news/54",
    src: require("@/assets/images/zh-TW/news/new_54.jpg"),
    component: () => import("@/components/news/News54.vue"),
    video: false,
  },
  { // 文章
    id: "53",
    title: "【 TSK | 台灣微整形美容醫學會 】",
    time: "2024/12/16",
    link: "/news/53",
    src: require("@/assets/images/zh-TW/news/new_53.jpg"),
    component: () => import("@/components/news/News53.vue"),
    video: false,
  },
  { // 文章
    id: "51",
    title: "【 TSK | 臺灣整形外科醫學會年會 】",
    time: "2024/11/25",
    link: "/news/51",
    src: require("@/assets/images/zh-TW/news/new_51.jpg"),
    component: () => import("@/components/news/News51.vue"),
    video: false,
  },
  { // 文章
    id: "49",
    title: "【 TSK | TDA 臺灣皮膚科醫學會 】",
    time: "2024/11/06",
    link: "/news/49",
    src: require("@/assets/images/zh-TW/news/new_49.jpg"),
    component: () => import("@/components/news/News49.vue"),
    video: false,
  },
  { // 文章
    id: "47",
    title: "【 TSK | 臺灣醫用雷射光電學會 秋季學術研討會 】",
    time: "2024/10/16",
    link: "/news/47",
    src: require("@/assets/images/zh-TW/news/new_47.jpg"),
    component: () => import("@/components/news/News47.vue"),
    video: false,
  },
  { // 文章
    id: "45",
    title: "【 TSK | ISDS 國際皮膚外科學會 】",
    time: "2024/08/28",
    link: "/news/45",
    src: require("@/assets/images/zh-TW/news/new_45.jpg"),
    component: () => import("@/components/news/News45.vue"),
    video: false,
  },

  { // 文章
    id: "31",
    title: "【2023 TDA臺灣皮膚科醫學會】",
    time: "2023/11/06",
    link: "/news/31",
    src: require("@/assets/images/zh-TW/news/new_31.jpg"),
    component: () => import("@/components/news/News31.vue"),
    video: false,
  },
  { // 文章
    id: "30",
    title: "【臺灣醫用雷射光電學會 2023秋季年會】",
    time: "2023/09/18",
    link: "/news/30",
    src: require("@/assets/images/zh-TW/news/new_30.jpg"),
    component: () => import("@/components/news/News30.vue"),
    video: false,
  },

  { // 影片
    id: "27",
    title: "【OBSERV 520x_全臉影像分析檢測儀 分享篇】",
    time: "2023/08/01",
    src: require("@/assets/images/zh-TW/news/new_27.jpg"),
    link: "https://www.youtube.com/embed/On229d8VTnY",
    video: true,
  },
  { // 影片
    id: "23",
    title: "【AMWC Asia-TDAC 2023 花絮】",
    time: "2023/05/10",
    src: require("@/assets/images/zh-TW/news/new_23.jpg"),
    link: "https://www.youtube.com/embed/SO5wT1mgSBY",
    video: true,
  },
  { // 文章
    id: "22",
    title: "【AMWC Asia-TDAC 2023 Workshop】",
    time: "2023/04/14",
    link: "/news/22",
    src: require("@/assets/images/zh-TW/news/new_22.jpg"),
    component: () => import("@/components/news/News22.vue"),
    video: false,
  },
  { // 文章
    id: "21",
    title: "【AMWC Asia-TDAC 2023】",
    time: "2023/04/10",
    link: "/news/21",
    src: require("@/assets/images/zh-TW/news/new_21.jpg"),
    component: () => import("@/components/news/News21.vue"),
    video: false,
  },
  { // 影片
    id: "20",
    title: "【2023 臺灣醫用雷射光電學會 花絮】",
    time: "2023/03/29",
    src: require("@/assets/images/zh-TW/news/new_20.jpg"),
    link: "https://www.youtube.com/embed/20txltA8zyk",
    video: true,
  },
  { // 影片
    id: "19",
    title: "【OBSERV 520x_全臉影像分析檢測儀 形象篇】",
    time: "2023/03/29",
    src: require("@/assets/images/zh-TW/news/new_19.jpg"),
    link: "https://www.youtube.com/embed/C1TWTekjMQk",
    video: true,
  },
  { // 文章
    id: "16",
    title: "【2023 臺灣醫用雷射光電學會】",
    time: "2023/03/01",
    link: "/news/16",
    src: require("@/assets/images/zh-TW/news/new_16.jpg"),
    component: () => import("@/components/news/News16.vue"),
    video: false,
  },
  { // 外部連結
    id: "15",
    title: "【OBSERV®肌膚旅歷｜功能特色】",
    time: "2023/02/15",
    //description:
    //"OBSERV 協助全面洞察客戶臉部狀況，讓醫學美容顧問可藉由輪廓比例、膚質及毛孔狀況...等各功能，輕鬆掌握客戶面部優勢，為客戶提供多元評估依據。",
    src: require("@/assets/images/zh-TW/news/new_15.jpg"),
    link: "https://observ.com.tw/features/OBSERV520x_features.html",
    video: false,
  },
  { // 影片
    id: "14",
    title: "【OBSERV 520x 360º光源模式】",
    time: "2023/02/08",
    src: require("@/assets/images/zh-TW/news/new_14.jpg"),
    link: "https://www.youtube.com/embed/cEpfiZYWPuw",
    video: true,
  },

  { // 文章
    id: "05",
    title: "Workshop at AMWC 2022",
    time: "2022/05/07",
    link: "/news/05",
    src: require("@/assets/images/zh-TW/news/new_05.jpg"),
    //articleImg: require("@/assets/images/zh-TW/news/Article_Banner8.jpg"),
    component: () => import("@/components/news/News05.vue"),
    video: false,
  },
  { // 文章
    id: "02",
    title: "【Workshop at AMWC 2021】",
    time: "2021/05/02",
    link: "/news/02",
    src: require("@/assets/images/zh-TW/news/new_02.jpg"),
    component: () => import("@/components/news/News02.vue"),
    video: false,
  },
  { // 影片
    id: "01",
    title: "【AMWC 2021 Highlights】",
    time: "2021/05/01",
    src: require("@/assets/images/zh-TW/news/new_01.jpg"),
    link: "https://www.youtube.com/embed/PEOcCgG-_IY",
    video: true,
  },
  { // 影片
    id: "00",
    title: "【2021 臺灣醫用雷射光電學會】",
    time: "2021/03/27",
    src: require("@/assets/images/zh-TW/news/new_00.jpg"),
    link: "https://www.youtube.com/embed/9KMuw2rDCSw",
    video: true,
  },

]
export default news